import { render, staticRenderFns } from "./EntryClosedMain.vue?vue&type=template&id=5563d6d6&scoped=true&"
import script from "./EntryClosedMain.vue?vue&type=script&lang=js&"
export * from "./EntryClosedMain.vue?vue&type=script&lang=js&"
import style0 from "./EntryClosedMain.vue?vue&type=style&index=0&id=5563d6d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5563d6d6",
  null
  
)

export default component.exports